module.exports = __webpack_public_path__ + "img/camera_board2.e14261a4.png";